import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mpolicy-privacy',
  templateUrl: './policy-privacy.component.html',
  styleUrls: ['./policy-privacy.component.scss']
})
export class MpolicyPrivacyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
